module.exports = __webpack_public_path__ + "img/pr-6.e1fd49f2.png";